import Dayjs from "dayjs"
import {DATE_FORMAT_HOUR_DEFAULT, DATE_FORMAT_DEFAULT} from "@/util/const"

export default class ReservationRequestDTO {
  constructor(item = {}) {
    this.id = item ? item.id : null
    this.examDate = item ? Dayjs(
      new Date(item.datetime).toLocaleString("en-US", {timeZone: "Europe/Amsterdam"})
    ).format(DATE_FORMAT_HOUR_DEFAULT) : null
    this.date = item ? Dayjs(
      new Date(item.datetime).toLocaleString("en-US", {timeZone: "Europe/Amsterdam"})
    ).format(DATE_FORMAT_DEFAULT) : null
    this.location = item ? item.location : null
    this.productName = item ? item.product_name : null
    this.code = item ? item.reservation_code : null
  }
}